import React from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: boolean;
  helperText?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, label, error, helperText, id, ...props }, ref) => {
    const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;
    const hasError = error && typeof error === 'boolean';

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-text-primary mb-1.5"
          >
            {label}
          </label>
        )}
        <input
          type={type}
          id={inputId}
          aria-invalid={hasError ? 'true' : undefined}
          aria-describedby={helperText ? `${inputId}-helper` : undefined}
          className={cn(
            'flex h-11 w-full rounded-md border bg-surface px-4 py-3 text-base text-text-primary placeholder:text-text-muted ring-offset-background transition-all duration-200 focus-visible:outline-none focus-visible:border-primary-500 focus-visible:ring-2 focus-visible:ring-primary-100 disabled:cursor-not-allowed disabled:opacity-50',
            hasError ? 'border-error-dark focus-visible:ring-error-light' : 'border-border hover:border-neutral-400',
            className
          )}
          ref={ref}
          {...props}
        />
        {helperText && (
          <p
            id={`${inputId}-helper`}
            className={cn('mt-1.5 text-sm text-text-muted', hasError && 'text-error-dark')}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
